export function getVariants(variantAttrs, variants) {
  const newVariants = variantAttrs.reduce(getCombReducer, [])
  newVariants.forEach(variant => {
    copyCurrentVariantProperties(variant, variants)
  })
  return newVariants;
}

function copyCurrentVariantProperties(variant, currentVariants) {
  for(let i = 0; i < currentVariants.length; i++) {
    const v = currentVariants[i];
    //console.log(v, isSameVariant(variant, v))
    if (isSameVariant(variant, v)) {
      //console.log(v, variant)
      variant.productVariantId = v.productVariantId;
      variant.sku = v.sku;
      variant.inventory = v.inventory;
      variant.price = v.price;
      variant.enabled = v.enabled;
    }
  }
}

// check if the two variant have the same variant options
function isSameVariant(v1, v2){
  //console.log(v1, v2)
  if (!v1.variantOptions || !v2.variantOptions || v1.variantOptions.length !== v2.variantOptions.length) return false;
  for(let i = 0; i < v1.variantOptions.length; i++) {
    let found = null;
    for(let j = 0; j < v2.variantOptions.length; j++) {
      if (v1.variantOptions[i].name === v2.variantOptions[j].name && v1.variantOptions[i].value === v2.variantOptions[j].value) {
        found = v2.variantOptions[j]
        break;
      }
    }
    //console.log(found)
    if (!found) return false;
  }
  //console.log('success')
  return true;
}

//variantName: (attr.displayName || attr.name) + ' - ' + (opt.displayName || opt.value),
function getCombReducer(accumulator, attr) {
  //console.log(accumulator, accumulator.length, attr)
  const variants = [];
  if (accumulator.length > 0) {
    accumulator.forEach(acc => {
      attr.options.forEach(opt => {
        variants.push({
          variantOptions: [...acc.variantOptions, getAttrOpt(attr, opt)],
          productVariantId: null,
          sku: '',
          inventory: null,
          price: null,
          enabled: true
        })
      })
    })
  } else {
    attr.options.forEach(opt => {
      variants.push({
        variantOptions: [getAttrOpt(attr, opt)]
      })
    })
  }
  return variants;
}

function getAttrOpt(attr, opt) {
  return {
    name: attr.name,
    value: opt.value,
  }
}
